import { useContext, createContext } from 'react';

interface SettingsPageContextValue {
    isDraft?: boolean;
    isEditable?: boolean;
    hasUnsavedChanges?: boolean;
    setHasUnsavedChanges?: (hasUnsavedChanges: boolean) => void;
}

export const SettingsPageContext = createContext<SettingsPageContextValue>({});

export const useSettingsPageContext = () => {
    return useContext(SettingsPageContext);
};
